import {
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_FAILURE,
  GET_PRODUCT_LIST_SUCCESS,
} from "../actions/product";

const INITIAL_STATE = {
  isGettingProductList: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCT_LIST:
      return {
        ...state,
        isGettingProductList: true,
        error: null,
      };

    case GET_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        isGettingProductList: false,
        products: action.payload.data,
      };

    case GET_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        isGettingProductList: false,
        error: action.error,
      };

    default:
      return state;
  }
};
